import { BehaviorSubject, Observable, of } from 'rxjs';
import { AccountCustomizedTexts } from '../account-customized-texts';
import { IAuthenticationService } from '../account-services';
import { IOAuthPopupService, OAuthProvider, SUPPORTED_OAUTH_PROVIDERS_BY_PRIORITY } from '../o-auth';
import { OAuthPopupServiceMock } from './o-auth-popup-service-mock';

export class AuthenticationServiceMock implements IAuthenticationService {
  private applicationVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  private gotoActionReplaceUrlDefault$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getAppStartParams(): undefined {
    return undefined;
  }

  adjustRedirectUrl(url: string): string {
    return '/adjusted' + url;
  }

  getStartupObservable(): Observable<unknown> {
    return of(null);
  }

  getGotoActionReplaceUrlDefault(): Observable<boolean> {
    return this.gotoActionReplaceUrlDefault$.asObservable();
  }

  getRouteParent(): string {
    return '/authentication';
  }

  isApplicationVisible(): Observable<boolean> {
    return this.applicationVisible$.asObservable();
  }

  closeApplicationOnSignOut(): boolean {
    return false;
  }

  finishAuthenticationWithoutRedirection(): Observable<unknown> {
    return of(null);
  }

  adjustConfirmSignUpSuccessNotification(): Observable<unknown> {
    return of(null);
  }

  finishConfirmAuthenticationEmailWithoutRedirection(): Observable<unknown> {
    return of(null);
  }

  finishResetPasswordWithoutRedirection(): Observable<unknown> {
    return of(null);
  }

  finishSetPasswordWithoutRedirection(): Observable<unknown> {
    return of(null);
  }

  setApplicationVisible(applicationVisible: boolean): void {
    this.applicationVisible$.next(applicationVisible);
  }

  setGotoActionReplaceUrlDefault(gotoActionReplaceUrlDefault: boolean): void {
    this.gotoActionReplaceUrlDefault$.next(gotoActionReplaceUrlDefault);
  }

  getOAuthPopupService(): IOAuthPopupService {
    return new OAuthPopupServiceMock();
  }

  getAccountCustomizedTexts(): AccountCustomizedTexts {
    return {} as AccountCustomizedTexts;
  }

  getOrderedOAuthProviders(): Observable<OAuthProvider[]> {
    return of(SUPPORTED_OAUTH_PROVIDERS_BY_PRIORITY);
  }

  getSuccessLottiePath(): string | null {
    return null;
  }

  setHeaderDataField(): string | null {
    return null;
  }
}
